import type { ChartUnit } from '../../../../../core/types/chart-unit.js';
import {
  Timeseries,
  TimeseriesDatapoint,
} from '../../../../../core/types/timeseries.js';

export const convertToTimeseriesArray = (
  selectedDatapoints: Map<
    string | string[],
    (TimeseriesDatapoint & { unit: ChartUnit })[]
  >,
) => {
  let timeseries: Timeseries[] = [];
  selectedDatapoints.forEach((value, key) => {
    const datapointsArray = [...value];
    const unit = datapointsArray[0].unit;
    const datapoints = datapointsArray.map(({ start, end, center, value }) => ({
      start,
      end,
      center,
      value,
    }));

    timeseries = [...timeseries, { name: key, unit, datapoints }];
  });
  return timeseries;
};
